module.exports = __webpack_public_path__ + "01d0cfdc2bb0d8e8154da10e6eef943b.svg";